function Card({image, name, description, url}) {
  return (
    <a className="card" title={description} href={url} target="_blank" rel="noopener noreferrer">
      <div className="card-image">
          <img src={image} alt={name}></img>
      </div>
      <div className="card-content">
        <h5 className="title is-4">{name}</h5>
      </div>
    </a>
  )
}

export default Card;